import axios from 'axios';

export default axios.create({
  //baseURL: 'https://app.bluefaucet.com/bluefaucet/api/',
  baseURL: 'https://bluefaucet.mandanstaging.com/bluefaucet/api/',
  timeout: 500000,
  headers: {
      "Content-Type": "multipart/form-data"
  }
});